<template>
  <div class="vcmi-loading-animation">
    <div class="vcmi-loader"></div>
    <div class="vcmi-loader-center"><div class="vcmi-loader-center-negative"></div></div>
  </div>
</template>

<script>
export default {
  name: "Loading",
};
</script>

<style lang="css" scoped>
.vcmi-loader {
  border: 32px solid #0091be;
  border-radius: 50%;
  border-bottom: 32px solid #0091be00;
  background-color: #00000000;
  width: 92px;
  height: 92px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  box-sizing: content-box;
}

.vcmi-loader-center {
  width: 60px;
  height: 60px;
  background-color: #0ff00000;
  border-radius: 50%;
  overflow: hidden;
  margin: auto;
  box-sizing: content-box;

  transform: translate(0px, -108px);
}

.vcmi-loader-center-negative {
  width: 25px;
  height: 40px;
  border-radius: 50%;
  transform: rotate(45deg) translate(-5px, -5px);
  box-shadow: 0px 0px 0px 2000px #000000;
}

.vcmi-loading-animation {
  width: 156px;
  height: 156px;
  text-align: center;
  padding: 0px;
  display: block;

  position: absolute;
  left: 0; 
  right: 0;
  top: 0;
  bottom: 0;

  margin: auto;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
